"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
/**
 * DONT USE YET
 * Hook that checks clicks outside of the passed ref
 */
function useOutsideClick(ref, value, setValue) {
    react_1.useEffect(function () {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setValue(!value);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);
}
function useOutside(state) {
    if (state === void 0) { state = false; }
    var _a = react_1.useState(state), open = _a[0], setOpen = _a[1];
    var wrapperRef = react_1.useRef(null);
    var Wrapper = function (_a) {
        var children = _a.children;
        useOutsideClick(wrapperRef, open, setOpen);
        if (!open) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        return react_1.default.createElement("div", { ref: wrapperRef }, children);
    };
    return [
        function () { return setOpen(!open); },
        function () { return setOpen(false); },
        Wrapper,
    ];
}
exports.default = useOutside;
